import client from '../client';
import {
  BASE_ENDPOINTS,
  SERVICES,
  VERSIONS,
  RESOURCES
} from '../common/constants';

// Define the base endpoint for weather
const WEATHER_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.WEATHER,
  false // No tenant ID in the base URL
);

export const getWeatherReportdata = ({
  cursor,
  district_ids,
  state_ids,
  limit,
  filter
}) =>
  client.post(`${WEATHER_BASE}/forcast`, {
    district_ids: district_ids,
    state_ids,
    cursor: cursor,
    limit: limit,
    search_text: filter
  });
